import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { NebulaConfirmationConfig } from '@scientifica-cms-fe/services/confirmation';
import {
    NebulaMediaWatcherModule
} from '@scientifica-cms-fe/services/media-watcher/media-watcher.module';
import {

    NebulaSplashScreenModule
} from '@scientifica-cms-fe/services/splash-screen/splash-screen.module';
import { NebulaTailwindConfigModule } from '@scientifica-cms-fe/services/tailwind/tailwind.module';
import { NebulaUtilsModule } from '@scientifica-cms-fe/services/utils/utils.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
@NgModule({
    imports: [
        NebulaConfirmationConfig,
        NebulaMediaWatcherModule,
        NebulaSplashScreenModule,
        NebulaTailwindConfigModule,
        NebulaUtilsModule,
        MatSnackBarModule
    ],
    providers: [
        {
            // Disable 'theme' sanity check
            provide: MATERIAL_SANITY_CHECKS,
            useValue: {
                doctype: true,
                theme: false,
                version: true
            }
        },
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill'
            }
        }
    ], exports: [
        MatSnackBarModule
    ]
})
export class NebulaCMSModule {
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: NebulaCMSModule) {
        if (parentModule) {
            throw new Error('NebulaCMSModule has already been loaded. Import this module in the AppModule only!');
        }
    }
}
